import React, { Component } from "react";
import { view } from "react-easy-state";
import { widget } from "../dockable";
import store from "../state.js";
import StrokePreview from "../components/StrokePreview";
import BrushCursor from "../components/BrushCursor";
import UnitInput from "../components/UnitInput";
import css from "./BrushControls.module.css";

class BrushControls extends Component {
  static defaultProps = {
    actions: () => [
      {
        type: "actions",
        actions: {
          "Do a Thing": function() {
            console.log("i did a thing");
          },
          "Do a Second Thing": function() {
            console.log("i did a second thing");
          },
          "Do Another Thing": function() {
            console.log("i did another thing");
          },
          "Increase Brush Size": function() {
            store.brush.size = parseInt(store.brush.size, 10) + 10;
          }
        }
      },
      {
        type: "enum",
        selected: store.brush.enumSelection,
        options: ["thing 1", "thing 2", "thing 3"],
        onChange: function(i) {
          store.brush.enumSelection = i;
        }
      },
      {
        type: "bools",
        options: {
          "Bool 1": {
            value: store.brush.bool1,
            function: function() {
              store.brush.bool1 = !store.brush.bool1;
            }
          },
          "Bool 2": {
            value: store.brush.bool2,
            function: function() {
              store.brush.bool2 = !store.brush.bool2;
            }
          },
          "Bool 3": {
            value: store.brush.bool3,
            function: function() {
              store.brush.bool3 = !store.brush.bool3;
            }
          }
        }
      }
    ]
  };

  handleBrushSize = value => {
    store.brush.size = value;
  };
  handleBrushSizeControl = value => {
    store.brush.sizeControl = value;
  };
  handleBrushHardness = value => {
    store.brush.hardness = value;
  };
  handleBrushFlow = value => {
    store.brush.flow = value;
  };
  handleBrushFlowControl = value => {
    store.brush.flowControl = value;
  };
  handleBrushSpacing = value => {
    store.brush.spacing = value;
  };
  handleBrushRoundness = value => {
    store.brush.roundness = value;
  };
  handleBrushAngle = value => {
    store.brush.angle = value;
  };

  render() {
    let previewBrush = Object.assign({}, store.brush);
    previewBrush.size = 70;

    return (
      <div className={css.container}>
        <StrokePreview key={-1} brush={store.brush} />
        <BrushSlider
          label={"Size"}
          value={store.brush.size}
          min={1}
          max={256}
          suffix={" px"}
          pressureToggle={store.brush.sizeControl}
          onValueChange={this.handleBrushSize}
          onPressureToggle={this.handleBrushSizeControl}
        />
        <BrushSlider
          label={"Flow"}
          value={store.brush.flow}
          min={1}
          max={100}
          suffix={"%"}
          pressureToggle={store.brush.flowControl}
          onValueChange={this.handleBrushFlow}
          onPressureToggle={this.handleBrushFlowControl}
        />
        <BrushSlider
          label={"Hardness"}
          value={store.brush.hardness}
          min={5}
          max={100}
          suffix={"%"}
          onValueChange={this.handleBrushHardness}
        />
        <BrushSlider
          label={"Spacing"}
          value={store.brush.spacing}
          min={0}
          max={100}
          suffix={"%"}
          onValueChange={this.handleBrushSpacing}
        />
        <div style={{ display: "flex" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className={css.brushPreview}>
              <div className={css.brushPreviewCentered}>
                <BrushCursor
                  cursorPos={[0, 0, 0]}
                  brush={previewBrush}
                  direction={true}
                  hardness={true}
                />
              </div>
            </div>
          </div>
          <div style={{ flexGrow: 1 }}>
            <BrushSlider
              label={"Roundness"}
              value={store.brush.roundness}
              min={5}
              max={100}
              suffix={"%"}
              onValueChange={this.handleBrushRoundness}
            />
            <BrushSlider
              label={"Angle"}
              value={store.brush.angle}
              min={0}
              max={180}
              suffix={"°"}
              onValueChange={this.handleBrushAngle}
              isLast
            />
          </div>
        </div>
      </div>
    );
  }
}

class BrushSlider extends Component {
  state = {
    value: this.props.value
  };

  // not sure why this is needed anymore.  It's thowing a warning, so I'm
  // going to comment it out until I remember why it was needed ;)
  // componentWillReceiveProps(newProps) {
  //   this.setState({ value: newProps.value });
  // }

  handleTextValueChange = e => {
    let textValue = e.target.value;
    if (isNaN(textValue)) {
      textValue = textValue
        .substring(0, textValue.length - this.props.suffix.length)
        .trim();
      if (isNaN(textValue)) return;
    } else {
      e.target.setSelectionRange(0, 10);
    }
    if (textValue === "") textValue = "0";

    textValue = parseInt(textValue, 10);

    textValue = textValue.toString();
    e.target.value = `${textValue}${this.props.suffix}`;
    e.target.setSelectionRange(textValue.length, textValue.length);

    if (isNaN(textValue)) return;
    this.setState({ value: textValue });

    e.preventDefault();
  };
  handleValueChange = e => {
    this.props.onValueChange(e.target.value);
  };
  handlePressureToggle = e => {
    this.props.onPressureToggle(!this.props.pressureToggle);
  };
  validate = e => {
    let value = parseInt(this.state.value, 10);
    value = Math.min(value, this.props.max);
    value = Math.max(value, this.props.min);
    this.props.onValueChange(value);
  };
  focus = e => {
    e.target.setSelectionRange(0, e.target.value.length);
  };

  render() {
    return (
      <div
        key={0}
        className={`${css.sliderContainer} + ${
          this.props.isLast ? css.last : ""
        }`}
      >
        <div className={css.sliderHeader}>
          <div className={css.label}>
            <label>{this.props.label}</label>
          </div>
          {this.props.pressureToggle !== undefined ? (
            <div
              className={`${css.pressureSwitch} ${
                this.props.pressureToggle ? css.active : ""
              }`}
              onClick={this.handlePressureToggle}
            />
          ) : null}
          <UnitInput
            label={this.props.label}
            value={this.props.value}
            min={this.props.min}
            max={this.props.max}
            suffix={this.props.suffix}
            onValueChange={this.props.onValueChange}
          />
        </div>
        <input
          type="range"
          min={this.props.min}
          max={this.props.max}
          value={this.props.value}
          onChange={this.handleValueChange}
          className={css.slider}
          tabIndex={-1}
        />
      </div>
    );
  }
}

export default view(
  widget(BrushControls, {
    id: "BrushControls",
    title: "Brush Settings",
    minHeight: 378
  })
);
